import { Geo } from "@tenderd/schema";
import { DefaultProvider, SplashScreen } from "@tenderd/track-web-utils";
import React, { Suspense, lazy } from "react";
import { useRouteMatch, Switch, Route, Redirect } from "react-router-dom";
import { useTranslation } from "./translations/hooks";

import { AppTKeys } from "./translations/keys";
const CustomLoginPage = lazy(() => import("./pages/CustomLoginPage"));
const LoginPage = lazy(() => import("./pages/LoginPage"));
const SignupPage = lazy(() => import("./pages/SignupPage"));
const AccountPickerPage = lazy(() => import("./pages/AccountPickerPage"));
const OnboardingPage = lazy(() => import("./pages/Onboarding"));

import "./styles.css";

const AuthExtension: React.FC<{}> = ({ }) => {
    let { path } = useRouteMatch<{ geo: Geo }>();
    const { i18n, t } = useTranslation();

    return (
        <div className="auth-extension">

            <img style={{ position: "absolute", top: 0, left: 0, bottom: 0 }} src="https://tenderd.com/images/shape-2.svg" />
            <img style={{ opacity: 0.1, position: "absolute", top: 0, right: 0, bottom: 0 }} src="https://tenderd.com/images/shape-1.svg" />

            <img className="header"
                src="https://tenderd-ui.storage.googleapis.com/assets/logo.png"
                alt="Tenderd"
            />
            <Switch>
                <Route exact path={`${path}`}>
                    <Redirect to={`auth/login`} />
                </Route>

                <Route
                    path={`${path}/customlogin`}
                    render={(props) => (
                        <Suspense
                            fallback={
                                <SplashScreen fullHeight description={i18n.t(AppTKeys.automaticallyLoggingInMessage)} />
                            }
                        >
                            <div className="left-section">
                                <CustomLoginPage />
                            </div>

                            <div className="right-section">
                                <a href="https://tenderd.com/tenderd-track">
                                    <img
                                        src="https://tenderd-ui.storage.googleapis.com/assets/background-2.png?3"
                                        alt="Download Apps"
                                    />
                                </a>
                            </div>
                        </Suspense>
                    )}
                />
                <Route
                    path={`${path}/login`}
                    exact
                    render={(props) => (
                        <Suspense fallback={<SplashScreen fullHeight />}>
                            <div className="left-section">
                                <LoginPage />
                            </div>
                            <div className="right-section">
                                <a href="https://tenderd.com/tenderd-track">
                                    <img
                                        src="https://tenderd-ui.storage.googleapis.com/assets/background-2.png?3"
                                        alt="Download Apps"
                                    />
                                </a>
                            </div>
                        </Suspense>
                    )}
                />
                <Route
                    path={`${path}/signup`}
                    exact
                    render={(props) => (
                        <Suspense fallback={<SplashScreen fullHeight />}>
                            <div className="left-section">
                                <SignupPage />
                            </div>
                            <div className="right-section">
                                <a href="https://tenderd.com/tenderd-track">
                                    <img
                                        src="https://tenderd-ui.storage.googleapis.com/assets/background-2.png?3"
                                        alt="Download Apps"
                                    />
                                </a>
                            </div>
                        </Suspense>
                    )}
                />

                <Route path={`${path}/onboarding`} exact render={(props) => (
                    <Suspense fallback={<SplashScreen fullHeight />}>
                        <DefaultProvider>
                            <OnboardingPage />
                        </DefaultProvider>
                    </Suspense>
                )} />

                <Route
                    path={`${path}/accounts`}
                    exact
                    render={(props) => (
                        <Suspense fallback={<SplashScreen fullHeight />}>
                            <DefaultProvider>
                                <div className="left-section">
                                    <AccountPickerPage />
                                </div>
                                <div className="right-section">
                                    <a href="https://tenderd.com/tenderd-track">
                                        <img
                                            src="https://tenderd-ui.storage.googleapis.com/assets/background-2.png?3"
                                            alt="Download Apps"
                                        />
                                    </a>
                                </div>
                            </DefaultProvider>
                        </Suspense>
                    )}
                />
            </Switch>

        </div>
    );
}

export default AuthExtension;